export default __webpack_public_path__ + "static/media/item.d5a1a2fb.jpg";